import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';
import { LoadingState } from '../states/StateViews';

export function RequireAuthLayout() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <section className="adaptive-page">
        <LoadingState label="Checking your session…" />
      </section>
    );
  }

  if (status === 'guest') {
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" state={{ from }} replace />;
  }

  return <Outlet />;
}
